module.exports = __webpack_public_path__ + "img/modern_frozen_products_logo.8b5b3ce0.png";